module.exports = __webpack_public_path__ + "img/ic_video.b655f99a.svg";